export default __webpack_public_path__ + "static/media/innovation-man.2b12c03f.png";